// src/data/craftTerms.js - RULING 312, PHASE 1 (c): THE CRAFT WORDS IN ONE FILE.
//
// The crafts the platform offers are the crafts its installed agreements cover - the keys of COMMITTEE_LOOKUP
// (committeeData.js), never a list typed into a screen. NewClaim.js and DisciplineCases.js each carried their own
// <option> pair ("Yardmaster", "Mechanical Supervisor"); a pack that installs another craft would have had to find them.
// DEFAULT_CRAFT is the word a screen falls back to when a record names no craft - the yardmaster pack's, today. Records
// already written keep the craft they carry; nothing here rewrites stored data. Behaviour is unchanged (phase 1, ruling
// 312 item 8): the same two crafts, in the same order, and the same fallback word. scripts\test-agreement-registry.mjs
// proves it, and that no screen spells the craft list or the fallback out again.
import { COMMITTEE_LOOKUP } from './committeeData';
import CRAFT_WORDS from './craftWords.json';   // section 747: the installation's craft words

export const DEFAULT_CRAFT = CRAFT_WORDS.defaultCraft;   // section 747: from the installation's craft words

// The crafts offered on the intake screens, in COMMITTEE_LOOKUP's own order.
export const CRAFTS = CRAFT_WORDS.crafts.length ? CRAFT_WORDS.crafts.slice() : Object.keys(COMMITTEE_LOOKUP);

// The word for a record's craft, or the default when it names none.
// Section 807 (Bob 2026-10-26 12:48 ET): "make sure the division between the yms and t&e are selected by clicking a button
// for the craft". The installation's divisions (craftWords.json "divisions"); a division may carry its own words, which
// replace the installation's for a craft in it. An installation with one division shows no buttons.
export const DIVISIONS = Array.isArray(CRAFT_WORDS.divisions) ? CRAFT_WORDS.divisions.map((d) => ({ id: d.id, label: d.label, crafts: d.crafts.slice() })) : [];
export function divisionOfCraft(craft) {
  const c = String(craft || '').trim();
  const d = (CRAFT_WORDS.divisions || []).find((x) => x.crafts.includes(c));
  return d ? d.id : '';
}
// The crafts a screen offers once a division is picked: the division's crafts the installed tables actually route.
export function craftsInDivision(divisionId, offered) {
  const d = (CRAFT_WORDS.divisions || []).find((x) => x.id === divisionId);
  const list = offered || CRAFTS;
  return d ? list.filter((c) => d.crafts.includes(c)) : list.slice();
}
// The words for a craft (or a division id): its division's own words over the installation's.
export function wordsFor(craftOrDivision) {
  const k = String(craftOrDivision || '').trim();
  const d = (CRAFT_WORDS.divisions || []).find((x) => x.id === k || x.crafts.includes(k));
  return Object.assign({}, CRAFT_WORDS, (d && d.words) || {});
}

export function craftOf(record) {
  const c = String((record && record.craft) || '').trim();
  return c || DEFAULT_CRAFT;
}
